import { offSiteFeatures } from 'entities/campaign/features';
import { FrequencyCapType, IFrequencyCap } from '../entities/frequency-caps';
import { TFunction } from 'i18next';
import { ISelectOption } from '@salecycle/ui-component-library';

export const getAvailbleCapTypes = (): FrequencyCapType[] => {
  return ['abandonmentsPerPeriod', 'purchaseCheck'];
};

export const frequencyCapRulesFilter = rules =>
  rules.filter(rule => rule.value.hasOwnProperty('type') && rule.value.type === '.FrequencyCap');

export const availableFrequencyCapFeatures = (frequencyCaps: IFrequencyCap[], t: TFunction) => {
  const allFrequencyCapFeatures: string[] = frequencyCaps.map(frequencyCap => frequencyCap.type);
  const uniqueCapFeatures = [...new Set(allFrequencyCapFeatures)];
  return offSiteFeatures(t).filter(feature => !uniqueCapFeatures.includes(feature.value));
};

export const getSavedCapTypes = (caps: IFrequencyCap[]): string[] => Array.from(new Set(caps.map(cap => cap.type)));

export const hasAvailableCap = (caps: IFrequencyCap[], availableCaps: FrequencyCapType[]): boolean => {
  const capTypes = caps.map(cap => cap.type);
  const missingTypes = availableCaps.filter(item => capTypes.indexOf(item) < 0);
  return missingTypes.length > 0;
};

export const getFrequencyCapList = (): ISelectOption<string>[] => [
  {
    label: 'Abandonment Limit',
    value: 'abandonmentsPerPeriod',
  },
  {
    label: 'Purchase Check',
    value: 'purchaseCheck',
  },
];
